/* ------------------------------------*\
    #AUTOSUGGEST SCRIPT
\*------------------------------------ */

import Awesomplete from 'awesomplete';
import Component from '../../../../../src/js/module/component';
import libs from '../../../../../src/js/module/libs';

export default class Autosuggest extends Component {

    static componentName = 'autosuggest';

    static componentSelector = '.js-autosuggest';

    /**
     * [1] Minimum number of characters that the user must enter
     *     before the suggestions are displayed.
     *     This option has no effect if {@link openOnFocus} is set to `true`.
     * [2] Maximum number of suggestions to be displayed.
     * [3] Controls whether the first suggestion should be selected
     *     automatically.
     * [4] Controls whether the first suggestion should be selected
     *     when the user hits the Tab key while the input element
     *     still has the focus.
     * [5] `{0}` is used as an index placeholder.
     * [6] Display suggestions immediately as soon
     *     as the input element is focused.
     * [7] Show {@link listLabel} at top of the listbox.
     * [8] Restore default sort function, but without higher weighting
     *     of the shortest string length.
     */
    static defaultOptions = {
        autoFirst: false, // [3]
        listLabel: 'Suggestions',
        maxItems: 10, // [2]
        minChars: 1, // [1]
        openOnFocus: false, // [6]
        showListLabel: false, // [7]
        sort: (a, b) => (a < b ? -1 : 1), // [8]
        statusNoResults: 'No suggestions found',
        statusTypeXChar: 'Type {0} or more characters for suggestions', // [5]
        statusXResults: '{0} suggestions found', // [5]
        tabSelect: false, // [4]
    };

    constructor() {
        super(...arguments);

        if (!Awesomplete) {
            console.warn('WARNING: You are using "Autosuggest" without its necessary dependency "Awesomplete".');
            return;
        }

        const inputElement = this.element?.querySelector('.c-input__input');

        if (!inputElement) {
            console.warn('WARNING: "Autosuggest" cannot be initialized because the input element ".c-input__input" is missing.');
            return;
        }

        if (this.options.openOnFocus && !inputElement.readOnly) {
            this.options.minChars = 0;

            inputElement.addEventListener('focus', () => {
                this.awesomplete?.evaluate();
            });
        }

        this.awesomplete = new Awesomplete(inputElement, this.options);

        if (this.options.showListLabel) {
            inputElement?.closest('.awesomplete')?.classList.add('show-label');
        }
    }

}

Autosuggest.register();

if (Awesomplete) {
    libs.Awesomplete = Awesomplete;
}
